/**
 *
 * Asynchronously loads the component for ChatbotReport
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/ChatbotReport/loadable.js